





























import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapState, mapGetters } from 'vuex'
import firebase from '@/plugins/firebase'
import moment from '@/plugins/moment'
import ApiService from '@/api'
import { Customer } from '@/models'
import PhoneInput from '@/components/login/phoneInput.vue'
import { dateFormat, dateToIso, textToDate } from '@/lib/i18n'
import { AxiosError } from 'axios'

export type IFormSignup = Vue & { validate: () => boolean }

@Component({
  components: {
    PhoneInput
  },
  computed: {
    ...mapState(['showLogin']),
    ...mapGetters(['translate', 'translateFirebaseError'])
  },
  methods: {
    ...mapActions(['showLoading', 'hideLoading', 'setSucessAlert', 'setErrorAlert'])
  }
})
export default class LoginSignup extends Vue {
  name = ''
  email = ''
  phone = ''
  birthdate = ''
  password = ''
  phoneValid = false

  errorMessage: string | null = null
  nameRules: Record<symbol, unknown>[] = []
  emailRules: Record<symbol, unknown>[] = []
  birthdateRules: Record<symbol, unknown>[] = []
  passwordRules: Record<symbol, unknown>[] = []

  currentState!: string
  setSucessAlert!: (arg1: string) => void
  setErrorAlert!: (arg1: string) => void
  showLoading!: () => void
  hideLoading!: () => void
  translate!: (key: string) => string
  translateFirebaseError!: (error: AxiosError) => string

  get showErrorMessage () : boolean {
    return this.errorMessage !== null
  }

  get formSignup () : IFormSignup {
    return this.$refs.formSignup as IFormSignup
  }

  get getCustomer () : Customer {
    const customer : Customer = Customer.fromJson(this.$data)
    customer.birthdate_text_iso = dateToIso(textToDate(customer.birthdate))
    return customer
  }

  back () : void {
    this.$emit('update:currentState', 'signin')
  }

  submit () : void {
    this.errorMessage = null
    this.nameRules = [
      (v: string):string|boolean => !!v || this.translate('input.errors.requiredName') // ,
      // (v: string):string|boolean => /^\w+( +\w+)*$/.test(v) || 'Informe o seu nome e sobrenome'
    ]
    this.emailRules = [
      (v: string):string|boolean => !!v || this.translate('input.errors.requiredEmail'),
      (v: string):string|boolean => /.+@.+\..+/.test(v.trim()) || this.translate('input.errors.invalidEmail')
    ]
    this.passwordRules = [
      (v: string):string|boolean => !!v || this.translate('input.errors.requiredPassword'),
      (v: string):string|boolean => (v && v.length >= 5) || this.translate('input.errors.invalidPassswordLength')
    ]
    this.birthdateRules = [
      (v: string):string|boolean => !!v || this.translate('input.errors.requiredBirthdate'),
      (v: string):string|boolean => {
        const date = moment(v, dateFormat())
        return (v && v.length === 10 && date.isValid() && date.isBetween(new Date(1900, 1, 11), moment().subtract(1, 'day'))) || this.translate('input.errors.invalidBirthdate')
      }
    ]
    const self = this // eslint-disable-line @typescript-eslint/no-this-alias
    setTimeout(function () {
      if (self.formSignup.validate() && self.phoneValid) {
        self.showLoading()
        ApiService.register(self.getCustomer).then(() =>
          firebase.auth().signInWithEmailAndPassword(self.email.trim(), self.password)
            .catch(error => { self.errorMessage = self.translateFirebaseError(error) })
            .finally(() => self.hideLoading())
        ).catch((error: AxiosError) => {
          self.errorMessage = self.translateFirebaseError(error)
          self.hideLoading()
        })
      }
    })
  }
}
